import { styled } from "@mui/material/styles";
import Button from "@components/Button/Button";

export const StyledFilterButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  backgroundColor: theme.palette.background.navigation,
  color: theme.palette.text.brand,
  boxShadow: "none",
}));
